module.exports = __webpack_public_path__ + "static/media/data-view-activity-tracker-logo.61469ccd.png";